import React, { FC } from 'react';
import IPresentationPageProps from 'interfaces/IPresentationPageProps';
import imgReadySpinner from 'assets/img/img_ready_spinner.svg';
import styled from 'styled-components';
import colors from 'const/style/colors';
import fonts from 'const/style/fonts';
import { inject, observer } from 'mobx-react';
import FloatingFrame from 'components/FloatingFrame';

const Frame = styled(FloatingFrame)`
  .frame-counter {
    width:380px;
    height:380px;
    border-radius:347px;
    color:${colors.CFFFFFF};
    position:relative;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    .title {
      width:180px;
      ${fonts.H2_White};
      white-space:pre-line;
    }
    .counter {
      font: Bold 100px Noto Sans KR;
      color:${colors.CFFFFFF};
    }
  }
  .dimmer {
    background:${colors.C2C2C2C};
    opaicty: 0.1;
  }
  .spinner {
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background: url(${imgReadySpinner});
    background-size:100% 100%;
    background-repeat:no-repeat;
    animation: counter-spin 1s linear infinite;
  }
  @keyframes counter-spin {
    0% {transform:rotateZ(90deg);}
    100% {transform:rotateZ(450deg);}
  }
`;

const PresentationReadyCounter: FC<IPresentationPageProps> = ({presentation})=>{

  return (
    <Frame>
      <div className='frame-floating-content frame-counter'>
        <div className='spinner' />
        <div className='title'>{`곧 온라인 PT전형\n녹화가 시작됩니다.`}</div>
        <div className='counter'>
          {presentation?.presentationReadyCount}
        </div>
      </div>
      <div className='dimmer'>
      </div>
    </Frame>
  )
}

export default inject('presentation')(observer(PresentationReadyCounter));